import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Api_Caller } from "../../utils/Api";
import { useParams } from "react-router-dom";
import moment from "moment";
import { Spin } from "antd";
import VisitTagsImages from "./visitTags";
const Visits = () => {
  const { sessionId } = useParams();

  const auth = useSelector((state) => state.auth || {});

  const [loading, setLoading] = useState(false);
  const [visits, setVisits] = useState([]);
  const [visibleCount, setVisibleCount] = useState(10);
  const getVisits = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${process.env.REACT_APP_API_ALL}/${Api_Caller.getVisitsBySession}/${sessionId}`,
        {
          headers: {
            Authorization: `Bearer ${auth.accessToken}`,
          },
        },
      );

      setVisits(response.data.data || []);
    } catch (e) {
      console.log(e);
      setVisits([]);
      setVisibleCount(6);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (sessionId) {
      getVisits();
    }
  }, [sessionId]);

  return (
    <>
      <Spin spinning={loading} size="large">
        {!loading && visits?.length > 0
          ? visits.slice(0, visibleCount).map((item) => (
              <div className="all-cards bg-white card shadow-sm p-0 mb-4">
                <div className="row" key={item?.visitId}>
                  <div className="col-lg-12">
                    <div className="card-header bg-white d-flex justify-content-between align-items-center p-4">
                      <div>
                        <h5 className="mb-0 text-capitalize">
                          {item?.farmerName || "-"}
                        </h5>
                      </div>

                      <span className="badge bg-primary text-white">
                        {moment
                          .utc(item?.visitedAt)
                          .local()
                          .format("DD MMM YYYY hh:mm A")}
                      </span>
                    </div>
                  </div>

                  <div className="col-lg-6 mb-6" key={item?.visitId}>
                    <div className="p-4 row">
                      <div className="col-sm-6 mb-3">
                        <span className="d-block font-size-lg font-weight-bolder mb-1 text-capitalize">
                          Mobile:
                        </span>
                        <span className="font-weight-bold font-size-sm text-muted text-capitalize">
                          {item?.mobileNumber || "-"}
                        </span>
                      </div>

                      <div className="col-sm-6 mb-3">
                        <span className="d-block font-size-lg font-weight-bolder mb-1 text-capitalize">
                          Registered Mobile Number:
                        </span>
                        <span className="font-weight-bold font-size-sm text-muted text-capitalize">
                          {item?.registeredMobileNumber || "-"}
                        </span>
                      </div>

                      <div className="col-sm-6 mb-3">
                        <span className="d-block font-size-lg font-weight-bolder mb-1 text-capitalize">
                          Customer Id:
                        </span>
                        <span className="font-weight-bold font-size-sm text-muted text-capitalize">
                          {item?.customerId || "-"}
                        </span>
                      </div>

                      <div className="col-sm-6 mb-3">
                        <span className="d-block font-size-lg font-weight-bolder mb-1 text-capitalize">
                          Location:
                        </span>
                        <span className="font-weight-bold font-size-sm text-muted text-capitalize">
                          {item?.location?.address || "-"}
                        </span>
                      </div>

                      <div className="col-sm-6 mb-3">
                        <span className="d-block font-size-lg font-weight-bolder mb-1 text-capitalize">
                          Purpose:
                        </span>
                        <span className="font-weight-bold font-size-sm text-muted text-capitalize">
                          {item?.purposeOfVisit || "-"}
                        </span>
                      </div>

                      <div className="col-sm-6 mb-3">
                        <span className="d-block font-size-lg font-weight-bolder mb-1 text-capitalize">
                          App Downloaded:
                        </span>
                        <span className="font-weight-bold font-size-sm text-muted text-capitalize">
                          {item?.appDownloaded ? (
                            <span className="text-success">Yes</span>
                          ) : (
                            <span className="text-danger">No</span>
                          )}
                        </span>
                      </div>

                      <div className="col-sm-6 mb-3">
                        <span className="d-block font-size-lg font-weight-bolder mb-1 text-capitalize">
                          Farmer Registered:
                        </span>
                        <span className="font-weight-bold font-size-sm text-muted text-capitalize">
                          {item?.farmerRegistered ? (
                            <span className="text-success">Yes</span>
                          ) : (
                            <span className="text-danger">No</span>
                          )}
                        </span>
                      </div>

                      <div className="col-sm-6 mb-3">
                        <span className="d-block font-size-lg font-weight-bolder mb-1 text-capitalize">
                          Registration Method:
                        </span>
                        <span className="font-weight-bold font-size-sm text-muted text-capitalize">
                          {item?.registrationMethod || "-"}
                        </span>
                      </div>

                      <div className="col-sm-6 mb-3">
                        <span className="d-block font-size-lg font-weight-bolder mb-1 text-capitalize">
                          Remarks:
                        </span>
                        <span className="font-weight-bold font-size-sm text-muted text-capitalize">
                          {item?.remarks || "-"}
                        </span>
                      </div>

                      <div className="col-sm-6 mb-3">
                        <span className="d-block font-size-lg font-weight-bolder mb-1 text-capitalize">
                          Notes:
                        </span>
                        <span className="font-weight-bold font-size-sm text-muted text-capitalize">
                          {item?.notes || "-"}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 mb-6">
                    <VisitTagsImages visits={item} />
                  </div>
                </div>
              </div>
            ))
          : !loading && (
              <div className="col-12 text-center py-5">
                <h5 className="text-muted">No Data Available</h5>
              </div>
            )}

        {visibleCount < visits.length && (
          <div className="text-center mt-4">
            <button
              className="btn btn-primary font-weight-bold"
              onClick={() => setVisibleCount((prev) => prev + 2)}
            >
              Load More
            </button>
          </div>
        )}
      </Spin>
    </>
  );
};

export default Visits;
